export const convertBrTagsToNewline = (inputString: string) => {
  return inputString.replace(/<br\s*\/?>/gi, "\n");
};
